import { useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { classNames } from "primereact/utils";

import Dropdown from "../../../../components/inputs/Dropdown";
import { addStationWithCustomerId } from "../../../../services/clearing/customers";

const initialFormData = {
  stationId: "",
  customerId: "",
};
const AddStation = ({ classes, customers }) => {
  const [visible, setVisible] = useState(false);
  const [formData, setFormData] = useState(initialFormData);

  const toast = useRef(null);

  // Validate stationId required field
  const isStationIdValid = formData?.stationId && formData?.stationId !== "";

  // Map customers to DropdownOption format
  const customerOptions =
    customers?.map((customer: any) => ({
      name: customer?.["account_holder_name"],
      code: customer?.id,
    })) || [];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCustomerChange = (value) => {
    setFormData({
      ...formData,
      customerId: value?.code || "",
    });
  };

  const handleSubmit = async () => {
    const success = await addStationWithCustomerId(formData);
    if (success) {
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Station added successfully",
        life: 3000,
      });
      setFormData({
        stationId: "",
        customerId: "",
      });

      setVisible(false);
    } else {
      setVisible(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to add station",
        life: 3000,
      });
    }
  };

  const footerContent = (
    <div>
      <Button
        label="Clear"
        icon="pi pi-trash"
        onClick={() => setFormData(initialFormData)}
        outlined
        className="p-button-text"
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={handleSubmit}
        autoFocus
        disabled={!isStationIdValid}
      />
    </div>
  );

  return (
    <div className="w-full md:w-14rem flex md:justify-content-end">
      <Toast ref={toast} />
      <Button
        outlined
        label="Add Station"
        icon="pi pi-map-marker text-lg"
        onClick={() => setVisible(true)}
        className={classes}
      />
      <Dialog
        header="Add New Station"
        visible={visible}
        style={{ width: "50vw" }}
        footer={footerContent}
        onHide={() => {
          setVisible(false);
        }}
        className="p-4"
      >
        <div className="pt-2 p-fluid grid formgrid">
          <div className="field col-12 md:col-6">
            <label htmlFor="stationId" className="input-label">
              Station ID*
            </label>
            <InputText
              id="stationId"
              name="stationId"
              value={formData?.stationId}
              onChange={handleInputChange}
              className={classNames("input-field", {
                "p-invalid": !isStationIdValid,
              })}
            />
          </div>
          <div className="field col-12 md:col-6">
            <label htmlFor="customerId" className="input-label">
              Customer
            </label>
            <Dropdown
              options={customerOptions}
              value={
                customerOptions.find(
                  (option) => option.code === formData.customerId
                ) || null
              }
              onChange={handleCustomerChange}
              placeholder="No Customer"
              className="input-field"
              searchable={true}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default AddStation;
